export function fromDotEnv(key) {
  const value = process.env[key];
  if (value === undefined) {
    throw new Error(`Config '${key}' is not defined`);
  }
  return value;
}
